<div class="calendar">
  <!-- Static left descriptive column (unchanged styling) -->
  <div class="left-part">
    <div class="left-top">
      <div class="top-left-items">
        <!-- Los valores están ocultos, pero si se borran, se desconfigura el diseño -->
        <div class="week">.</div>
        <div class="dates">.</div>
        <div class="buttons">.</div>
      </div>
    </div>
    <div class="left-bottom">
      <div class="vertical-items">
        <div class="item">
          CAMIONES TOTAL
          <!-- <mat-icon>arrow_drop_down</mat-icon> -->
        </div>
        <div class="item">
          CAMIONES AVERIADOS
          <!-- <mat-icon>arrow_drop_down</mat-icon> -->
        </div>
        <div class="item">
          CAMIONES DISPONIBLES
          <!-- <mat-icon>arrow_drop_down</mat-icon> -->
        </div>
        <div class="item">
          CONDUCTORES TOTAL
          <!-- <mat-icon>arrow_drop_down</mat-icon> -->
        </div>
        <div class="item">
          CONDUCT. VACACIONES
          <!-- <mat-icon>arrow_drop_down</mat-icon> -->
        </div>
        <div class="item">
          CONDUCT. INDISPONIBLES
          <!-- <mat-icon>arrow_drop_down</mat-icon> -->
        </div>
        <div class="item">
          CONDUCT. PREVISIÓN
          <!-- <mat-icon>arrow_drop_down</mat-icon> -->
        </div>
        <div class="item">
          CONDUCT. DISPONIBLES
          <!-- <mat-icon>arrow_drop_down</mat-icon> -->
        </div>
        <div class="item">
          CAMIONES PARADOS
          <!-- <mat-icon>arrow_drop_down</mat-icon> -->
        </div>
        <div class="item">
          OBJETIVO CAMIONES PARADOS
          <!-- <mat-icon>arrow_drop_down</mat-icon> -->
        </div>
        <div class="item">
          SLOTS
          <!-- <mat-icon>arrow_drop_down</mat-icon> -->
        </div>
      </div>
    </div>
  </div>

  <div class="right-columns-scroll">
    @if (isLoading) {
    <!-- Skeleton loader -->
    @for (skeletonCol of [1, 2, 3]; track $index) {
    <div class="right-column skeleton">
      <div class="top-part">
        <div class="top-right-items">
          <div class="skeleton-line week-skeleton"></div>
          <div class="skeleton-line dates-skeleton"></div>
          <div class="buttons">
            <div class="skeleton-circle"></div>
            <div class="skeleton-circle"></div>
          </div>
        </div>
      </div>
      <div class="bottom-part">
        <div class="vertical-items">
          @for (row of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]; track $index) {
          <div class="item">
            <div class="skeleton-line metric-skeleton"></div>
          </div>
          }
        </div>
      </div>
    </div>
    } } @else if (rightColumns.length > 0) { @for (col of rightColumns; track
    $index) {
    <div class="right-column" [class.danger]="col.danger" [class.skeleton]="isRefreshingWeek(col.weekNumber)">
      @if (isRefreshingWeek(col.weekNumber)) {
      <!-- Skeleton loader for refreshing column -->
      <div class="top-part">
        <div class="top-right-items">
          <div class="skeleton-line week-skeleton"></div>
          <div class="skeleton-line dates-skeleton"></div>
          <div class="buttons">
            <div class="skeleton-circle"></div>
            <!-- <div class="skeleton-circle"></div> -->
            <div class="skeleton-circle"></div>
          </div>
        </div>
      </div>
      <div class="bottom-part">
        <div class="vertical-items">
          @for (row of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]; track $index) {
          <div class="item">
            <div class="skeleton-line metric-skeleton"></div>
          </div>
          }
        </div>
      </div>
      } @else {
      <!-- Normal column content -->
      <div class="top-part">
        <div class="top-right-items">
          <div class="week">
            @if(col.danger) {
            <mat-icon>error</mat-icon>
            }
            {{ col.week }}
          </div>
          <div class="dates">{{ col.dates }}</div>
          <div class="buttons">
            @if (!isEditingWeek(col.weekNumber)) {
            <button mat-icon-button (click)="editFields(col.weekNumber)">
              <mat-icon svgIcon="edit"></mat-icon>
            </button>
            } @else {
            <button mat-icon-button (click)="editFields(col.weekNumber)">
              <mat-icon>save_alt</mat-icon>
            </button>
            }
            <!-- <button mat-icon-button>
              <mat-icon>info_outline</mat-icon>
            </button> -->
            <button mat-icon-button (click)="onRefreshClick(col.weekNumber)">
              <mat-icon>refresh</mat-icon>
            </button>
          </div>
        </div>
      </div>
      <div class="bottom-part">
        <div class="vertical-items">
          @for (value of col.metrics; track $index) { @if
          (isEditingWeek(col.weekNumber) && ($index === 9 || $index === 10)) {
          <!-- Editable fields for last two rows -->
          <div class="item highlighted">
            <input type="number" [(ngModel)]="col.metrics[$index]" class="metric-input" />
          </div>
          } @else if (col.danger && $index === 1) {
          <div class="item">
            {{ value }}
            <mat-icon>error</mat-icon>
          </div>
          } @else if(col.danger && $index === 2) {
          <div class="item highlighted danger">
            {{ value }}
          </div>
          } @else if ($index === 2 || $index === 7 || $index === 8 || $index ===
          9) {
          <div class="item highlighted">{{ value }}</div>
          } @else {
          <div class="item">{{ value }}</div>
          } }
        </div>
      </div>
      }
    </div>
    } }
  </div>
</div>